import { render, staticRenderFns } from "./SubscriptionFrequency.vue?vue&type=template&id=17361f6d&"
import script from "./SubscriptionFrequency.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports